import { render, staticRenderFns } from "./BrandDescription.vue?vue&type=template&id=3cf995ef&scoped=true"
import script from "./BrandDescription.vue?vue&type=script&lang=js"
export * from "./BrandDescription.vue?vue&type=script&lang=js"
import style0 from "./BrandDescription.vue?vue&type=style&index=0&id=3cf995ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf995ef",
  null
  
)

export default component.exports